"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoyaltyDialog = exports.loyaltyDialogContext = exports.LoyaltyDialogProvider = void 0;
var _react = require("react");
const DEFAULT_CONTEXT_DATA = {
  catalogueItemId: '0',
  choiceId: 0,
  consultantPrice: 0,
  itemCode: '0',
  loyaltyPoints: 0,
  loyaltyPrice: 0,
  productName: 'none',
  quantity: 0
};
const loyaltyDialogContext = exports.loyaltyDialogContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_CONTEXT_DATA);
const LoyaltyDialogProvider = exports.LoyaltyDialogProvider = loyaltyDialogContext.Provider;
const useLoyaltyDialog = () => (0, _react.useContext)(loyaltyDialogContext);
exports.useLoyaltyDialog = useLoyaltyDialog;
